export function Active() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="layer-single">
        <path
          id="Icon"
          d="M8.23917 4.78499C8.15171 4.74126 8.10798 4.7194 8.06212 4.71079C8.02149 4.70317 7.97981 4.70317 7.93919 4.71079C7.89332 4.7194 7.84959 4.74126 7.76214 4.78499L1.33398 7.99907L7.76214 11.2131C7.84959 11.2569 7.89332 11.2787 7.93919 11.2873C7.97981 11.295 8.02149 11.295 8.06212 11.2873C8.10798 11.2787 8.15171 11.2569 8.23917 11.2131L14.6673 7.99907L8.23917 4.78499Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
